module.exports = __webpack_public_path__ + "static/media/imagenCentral.a87d405d.jpg";